export default __webpack_public_path__ + "static/media/icon_xing.a03b58f1.svg";